module.exports = __webpack_public_path__ + "img/pr-1.76763c62.png";